import React from 'react';

import musicI18n from '@cdo/apps/music/locale';
import {commonI18n} from '@cdo/apps/types/locale';
import {useAppSelector} from '@cdo/apps/util/reduxHooks';

import {TEXT_BASED_LABS} from '../../constants';
import {AppName} from '../../types';

import GenericDialog, {GenericDialogProps} from './GenericDialog';

// Lab-specific messages for starting over.
const LAB_SPECIFIC_MESSAGES: {[appName in AppName]?: string} = {
  ailab:
    'Starting over will wipe your current trained model and any training history. This cannot be reversed.',
  aichat:
    "This will reset this level to its start state and remove any model customizations or model card information you've added or changed.",
  music: musicI18n.startOverMusicWorkspace(),
};

/**
 * Start Over dialog used in Lab2 labs.
 */

export type StartOverDialogProps = GenericDialogProps & {
  handleConfirm: () => void;
  handleCancel?: () => void;
};

const StartOverDialog: React.FunctionComponent<StartOverDialogProps> = ({
  handleConfirm,
  handleCancel = () => {},
}) => {
  const currentAppName = useAppSelector(
    state => state.lab.levelProperties?.appName
  );

  const isTextWorkspace =
    currentAppName && TEXT_BASED_LABS.includes(currentAppName);

  const dialogMessage =
    (currentAppName && LAB_SPECIFIC_MESSAGES[currentAppName]) ||
    (isTextWorkspace
      ? commonI18n.startOverWorkspaceText()
      : commonI18n.startOverWorkspace());

  return (
    <GenericDialog
      title={commonI18n.startOverTitle()}
      message={dialogMessage}
      buttons={{
        confirm: {
          callback: handleConfirm,
          text: commonI18n.startOver(),
        },
        cancel: {
          callback: handleCancel,
        },
      }}
    />
  );
};

export default StartOverDialog;
